
import PropTypes from 'prop-types';

const CustomText = ({
    children,
    variant = 'body',
    color = '#000',
    italic = false,
    span = false,
    style,
    ...props
}) => {

    const textStyles = {
        fontFamily: 'Inter, sans-serif',
        margin: 0,
        color,
        letterSpacing: '0.2px',
        fontStyle: italic ? 'italic' : 'normal',
        ...getVariantStyles(variant),
        ...style,
    };

    const Component = span ? 'span' : variant.startsWith('headline') ? 'h1' : 'p';

    return (
        <Component style={textStyles} {...props}>
            {children}
        </Component>
    );
};

const getVariantStyles = (variant) => {

    const variants = {
        headline6xl: {
            fontSize: '60px',
            lineHeight: '60px',
            fontWeight: 700,
        },
        headline5xl: {
            fontSize: '48px',
            lineHeight: '48px',
            fontWeight: 700,
        },
        headline4xl: {
            fontSize: '36px',
            lineHeight: '43px',
            fontWeight: 700,
        },
        headline3xl: {
            fontSize: '30px',
            lineHeight: '39px',
            fontWeight: 700,
        },
        headline2xl: {
            fontSize: '24px',
            lineHeight: '32px',
            fontWeight: 700,
        },
        headlineXl: {
            fontSize: '20px',
            lineHeight: '28px',
            fontWeight: 700,
        },
        headlineLg: {
            fontSize: '18px',
            lineHeight: '28px',
            fontWeight: 700,
        },
        subtitle: {
            fontSize: '16px',
            lineHeight: '22px',
            fontWeight: 600,
        },
        subtitleSmall: {
            fontSize: '14px',
            lineHeight: '22px',
            fontWeight: 600,
        },
        body: {
            fontSize: '16px',
            lineHeight: '22px',
            fontWeight: 400
        },
        bodySmall: {
            fontSize: '14px',
            lineHeight: '22px',
            fontWeight: 300,
        },
        caption: {
            fontSize: '12px',
            lineHeight: '16px',
            fontWeight: 300,
        },
    };
    return variants[variant] || variants.body;
};

CustomText.propTypes = {
    children: PropTypes.node.isRequired,
    variant: PropTypes.oneOf([
        'headline6xl',
        'headline5xl',
        'headline4xl',
        'headline3xl',
        'headline2xl',
        'headlineXl',
        'headlineLg',
        'subtitle',
        'subtitleSmall',
        'body',
        'bodySmall',
        'caption',
    ]),
    color: PropTypes.string,
    italic: PropTypes.bool,
    style: PropTypes.object,
};

export default CustomText; 